    <!-- BEGIN: Sidebar -->
    <!-- BEGIN: Sidebar -->
    <div class="sidebar-wrapper group w-0  "
      [class.hidden]="dashcodeHelper.Settings.isSmallScreen && !dashcodeHelper.Settings.menuIsOpen"
      [class.sidebar-open]="dashcodeHelper.Settings.menuIsOpen">
      <div id="bodyOverlay" class="w-screen h-screen fixed top-0 bg-slate-900 bg-opacity-50 backdrop-blur-sm z-10 block"
        (click)="dashcodeHelper.menuToggle()" *ngIf="dashcodeHelper.Settings.isSmallScreen  && dashcodeHelper.Settings.menuIsOpen"></div>
      <div class="logo-segment">
        <a class="flex items-center" [routerLink]="['/']">
          <img src="assets/images/2023/logo-mobile.png" class="black_logo" alt="logo">
          <img src="assets/images/2023/logo-mobile.png" class="white_logo" alt="logo">
          <!-- <span class="ltr:ml-3 rtl:mr-3 text-xl font-Inter font-bold text-slate-900 dark:text-white">DashCode</span> -->
        </a>
        <!-- Sidebar Type Button -->
        <div id="sidebar_type" class="cursor-pointer text-slate-900 dark:text-white text-lg"
          (click)="dashcodeHelper.menuCollapse()" *ngIf="!dashcodeHelper.Settings.isSmallScreen">
          <span class="sidebarDotIcon extend-icon cursor-pointer text-slate-900 dark:text-white text-2xl">
            <div
              class="h-4 w-4 border-[1.5px] border-slate-900 dark:border-slate-700 rounded-full transition-all duration-150 ring-2 ring-inset ring-offset-4 ring-black-900 dark:ring-slate-400 bg-slate-900 dark:bg-slate-400 dark:ring-offset-slate-700">
            </div>
          </span>
          <span class="sidebarDotIcon collapsed-icon cursor-pointer text-slate-900 dark:text-white text-2xl">
            <div
              class="h-4 w-4 border-[1.5px] border-slate-900 dark:border-slate-700 rounded-full transition-all duration-150">
            </div>
          </span>
        </div>
        <button class="sidebarCloseIcon text-2xl" *ngIf="dashcodeHelper.Settings.isSmallScreen"
          (click)="dashcodeHelper.menuToggle()">
          <iconify-icon class="text-slate-900 dark:text-slate-200" icon="clarity:window-close-line"></iconify-icon>
        </button>
      </div>
      <div id="nav_shadow" class="nav_shadow h-[60px] absolute top-[80px] nav-shadow z-[1] w-full transition-all duration-200 pointer-events-none
        opacity-0"></div>
      <dashlayout-sidebar-menu></dashlayout-sidebar-menu>

    </div>
    <!-- End: Sidebar -->
    <!-- End: Sidebar -->
